import { __decorate } from "tslib";
import { Group, Vector3 } from 'three';
import { FemurAnalyzerAPConfig as Config } from '../../Config/FemurAnalyzerAPConfig.js';
import { LabelAngleConfig } from '../../Config/LabelAngleConfig.js';
import { LabelTextConfig } from '../../Config/LabeltextConfig.js';
import { Save, SaveChild } from '../../Core/Save.js';
import { ViewType } from '../../Models/AppModel.js';
import { Consts } from '../../Utils/Consts.js';
import { VectorUtils } from '../../Utils/VectorUtils.js';
import { CalculationPoint } from '../Primitive/CalculationPoint.js';
import { DraggablePoint } from '../Primitive/DraggablePoint.js';
import { Hexagon } from '../Primitive/Hexagon.js';
import { LabelAngle } from '../Primitive/Label/LabelAngle.js';
import { LabelText } from '../Primitive/Label/LabelText.js';
import { LinePointToPoint2 } from '../Primitive/LinePointToPoint2.js';
export class FemurAnalyzerAPMechanical extends Group {
    get apexBisector() {
        return VectorUtils.getBisector(this.FH.position.clone().sub(this.apex.position), this.CE.position.clone().sub(this.apex.position));
    }
    constructor(isLeft, isContralateral, limitLines) {
        super();
        this.name = 'FemurAnalyzerAPMechanical';
        this.add(this.GT = new DraggablePoint('GT', ViewType.AP, Config.GT_color), this.FH = new DraggablePoint('FH', ViewType.AP, Config.FH_color), this.LE = new DraggablePoint('LE', ViewType.AP, Config.LE_color), this.ME = new DraggablePoint('ME', ViewType.AP, Config.ME_color), this.CE = new CalculationPoint('CE'), this.ACE = new CalculationPoint('ACE'), this.LPFALabel = new LabelAngle({
            name: 'LPFALabel',
            arcA: this.GT,
            arcB: this.CE,
            arcCenter: this.FH,
            viewType: ViewType.AP,
            labelAnchor: new Vector3(0, -5),
            labelParams: { backgroundColor: Config.LPFALabel_backgroundColor, fontColor: Config.LPFALabel_fontColor },
            labelErrorParams: { backgroundColor: 'rgba(255, 0, 0, 0.6)', fontColor: '#ffffff' },
            minAngle: Consts.paleyAngles.AP.mLPFA.min,
            maxAngle: Consts.paleyAngles.AP.mLPFA.max,
            textCallback: (angle) => `LPFA ${angle}°`
        }), this.mLDFALabel = new LabelAngle({
            name: 'mLDFALabel',
            arcA: this.LE,
            arcB: this.FH,
            arcCenter: this.CE,
            arcColor: LabelAngleConfig.color,
            viewType: ViewType.AP,
            labelAnchor: new Vector3(isLeft ? 7 : -7, 5),
            labelParams: { backgroundColor: Config.mLDFALabel_backgroundColor, fontColor: Config.mLDFALabel_fontColor },
            labelErrorParams: { backgroundColor: 'rgba(255, 0, 0, 0.6)', fontColor: '#ffffff' },
            minAngle: Consts.paleyAngles.AP.mLDFA.min,
            maxAngle: Consts.paleyAngles.AP.mLDFA.max,
            textCallback: (angle) => `mLDFA ${angle}°`
        }), ...limitLines, this.GT_FH_Line = new LinePointToPoint2('GT_FH_Line', ViewType.AP, Config.GT_FH_Line_color, this.GT, this.FH), this.FH_CE_Line = new LinePointToPoint2('FH_CE_Line', ViewType.AP, Config.FH_CE_Line_color, this.FH, this.CE), this.LE_ME_Line = new LinePointToPoint2('LE_ME_Line', ViewType.AP, Config.LE_ME_Line_color, this.LE, this.ME));
        if (!isContralateral) {
            this.add(this.apex = new Hexagon(ViewType.AP, Config.apex_color), this.apexLabel = new LabelText({
                name: 'ApexLabel',
                color: LabelTextConfig.color,
                viewType: ViewType.AP,
                objToAnchor: this.apex,
                anchor: new Vector3(isLeft ? 7 : -7, 5),
                labelParams: { backgroundColor: Config.apexLabel_backgroundColor, fontColor: Config.apexLabel_fontColor, text: 'APEX' }
            }), this.proximalMechanicalAxis = new LinePointToPoint2('ProximalMechanicalAxis', ViewType.AP, Config.proximalMechanicalAxis_color, this.FH, this.apex, 2, 1, 1.5), this.distalMechanicalAxis = new LinePointToPoint2('DistalMechanicalAxis', ViewType.AP, Config.distalMechanicalAxis_color, this.CE, this.apex, 2, 1, 1.5));
        }
    }
}
__decorate([
    Save('position')
], FemurAnalyzerAPMechanical.prototype, "GT", void 0);
__decorate([
    Save('position')
], FemurAnalyzerAPMechanical.prototype, "FH", void 0);
__decorate([
    Save('position')
], FemurAnalyzerAPMechanical.prototype, "LE", void 0);
__decorate([
    Save('position')
], FemurAnalyzerAPMechanical.prototype, "ME", void 0);
__decorate([
    SaveChild()
], FemurAnalyzerAPMechanical.prototype, "LPFALabel", void 0);
__decorate([
    SaveChild()
], FemurAnalyzerAPMechanical.prototype, "mLDFALabel", void 0);
__decorate([
    SaveChild()
], FemurAnalyzerAPMechanical.prototype, "apexLabel", void 0);
//# sourceMappingURL=FemurAnalyzerAPMechanical.js.map